/**
 *
 * @param queryString
 * @returns {{}|{}}
 */
const parseQueryString = (queryString) =>
  (queryString &&
    queryString !== '?' &&
    queryString
      .substring(1)
      .split('&')
      .map((pair) => pair.split('='))
      .reduce(
        (params, [key, value]) => ({
          ...params,
          [key]: decodeURIComponent(value),
        }),
        {}
      )) ||
  {}

/**
 *
 * @param keyValues
 * @returns {string}
 */
const buildQuerystring = (keyValues) =>
  new URLSearchParams(keyValues).toString()

/**
 *
 * @param url
 * @param keyValues
 * @returns {`${string}${string}${string}`}
 */
const appendQuerystringToUrl = (url, keyValues) => {
  const querystringEncoded = buildQuerystring(keyValues)
  const separator = url.indexOf('?') === -1 ? '?' : '&'

  return `${url}${separator}${querystringEncoded}`
}

const getMarketingData = () => {
  try {
    const url = new URL(window.location.href)
    let queryString = url.search

    // Check if the hash part contains query parameters
    if (url.hash.includes('?')) {
      const hashQueryString = url.hash.split('?')[1]
      // Append the hash query string to the existing query string
      queryString = queryString
        ? `${queryString}&${hashQueryString}`
        : `?${hashQueryString}`
    }

    const urlParams = new URLSearchParams(queryString)

    const keys = ['utm_source', 'utm_medium', 'utm_campaign']
    const data = {}

    keys.forEach((key) => {
      if (urlParams.has(key)) {
        data[key] = urlParams.get(key)
      }
    })

    return data
  } catch (error) {
    console.error('Error parsing marketing data:', error)
    return {}
  }
}

export {
  parseQueryString,
  buildQuerystring,
  appendQuerystringToUrl,
  getMarketingData,
}
